export default {
    columns                 : _.map(['2','12','4','3','6'], id=>({id: id/*, aggregate: null*/})),
    systemStatusFilter      : 'open', // used is task table to show hide archived tasks
    sortBy                  : null,  // current sort by column value
    filters                 : {},
    areEmptyFoldersHidden   : false
};